export class AesRequestSpanTimeTable {
  id: number | null;
  team: string | null;
  eventType: string | null;
  requestNumber: string | null;
  requestDate: Date | null;
  routeDate: Date | null;
  spanTime: number | null;
  enteredById: string | null;
  enteredByUsername: string | null;
  responsibleId: string | null;
  responsibleUsername: string | null;
  enteredAtTimestamp: Date | null;
  updatedAtTimestamp: Date | null;
}
